
import { isUndefined, isNotUndefined, isEmpty, isNotEmpty } from "../util/util";
import { constMap } from "../const/const";
import { searchFormMap } from '../components/common/searchformmap'
import $ from 'jquery';
/**
 * 
 * 
 * @param {any} name 
 * @returns 
 */
export const getSearchFormMaxLength = (name) => {
    if (isUndefined(constMap.searchForm[name])) return;
    return constMap.searchForm[name].maxlength;
}

/**
* searchname,nameの値の一致するsearchname側の要素のng-modelのキーを取得する
* 
* @param {any} name searchnameと同じ値をもつname
* @returns 
*/
export const getSearchName = (name) => {

    const el = $('[searchname="' + name + '"]');
    return el.attr('name');
}

/**
 * scopeの中からkeyで指定したオブジェクトに値を設定する
 * 
 * @param {any} key オブジェクト名称を文字列で指定（"xxx.xxx"）
 * @param {any} state 参照するscopeを指定する
 * @param {any} data オブジェクトに設定する値
 * @returns 
 */
export const setValueByKey = (key, obj, data) => {
    if (isUndefined(obj)) return;
    const keys = key.split(".");
    let value = obj;

    if (keys.length === 1) {
        value[keys[keys.length - 1]] = data;
        return;
    }

    for (let i = 0; i < keys.length - 1; i++) {
        if (isNotEmpty(value[keys[i]])) {
            // Dateオブジェクト以外のオブジェクトを参照する
            if (typeof value[keys[i]] === "Object" && typeof value[keys[i]] === "Date") {
                value = value[keys[i]] // 参照オブジェクト
            }
        } else {
            value[keys[i]] = {} // 存在しない場合オブジェクトを生成する
        }
    }
    value[keys[keys.length - 1]] = data;
}

/**
* scopeの中からkeyで指定したオブジェクトの値を取得する
* 
* @param {any} key オブジェクト名称を文字列で指定（"xxx.xxx"）
* @param {any} state obj 参照するscopeを指定する
* @returns 
*/
export const getValueByKey = (key, state) => {

    if (isEmpty(key)) return;
    if (state[key] && typeof state[key] !== 'object' && !state[key].value) return state[key];
    return state[key];
}

/**
* 照会画面に引き継ぐ値を設定する
* 
* @param {any} state 
* @param {any} props 
*/
export const setPassThroughValue = (state, element, props) => {
    // searchformが設定されていない場合は処理しない
    if (isEmpty(props.searchform)) return;
    // 開く照会画面IDを取得する
    const modalGmnId = getModalGmnId(props.searchform);
    // 開く照会画面のIDが設定されている要素を取得する
    const modalGmnIdElements = element.closest("form").find('[pass-gmnid*="' + modalGmnId + '"]');
    if (modalGmnIdElements.length <= 0) return;

    // 照会画面に引き継ぐ値を初期化する
    initPssValue(state, element.closest("form").find('[pass-gmnid]'));
    modalGmnIdElements.forEach((ele) => {
        // 設定されている定数を取得する
        const passName = $(ele).attr("pass-name");

        // 照会画面の変数名を取得する
        const varName = getVarName(modalGmnId, passName);

        // 変数名が取得できない場合
        if (isEmpty(varName)) return true; // continue

        // MNTF022,023画面の相手商品コードをselectboxから設定する
        if (ele.tagName === "SELECT") {
            ele.forEach(ele, function (option) {
                // optionのvalueとselectboxで選択されている値が同じ場合
                if (option.value === $(ele).val()) {
                    // 選択されている値を設定する
                    setValueByKey(varName, state, $(ele).val());
                    // 選択されているテキストを設定する
                    setValueByKey(getVarName(modalGmnId, "EOSAITETKSAKIMEI"), state, option.text);
                    return false;  // break
                }
            });
            return true; // continue
        }

        // リストコントロール内に存在しているか確認するためindexを取得する
        const targetRowIndex = $(ele).parents("[data-row-index]").data("row-index");

        // リストコントロール内に存在する場合
        if (isNotEmpty(targetRowIndex)) {
            const ownRowIndex = element.parents("[data-row-index]").data("row-index");
            // 同じ行であれば値を設定する
            if (targetRowIndex === ownRowIndex) setValueByKey(varName, state, $(ele).val());
            return true; // continue
        }

        // 値を設定する
        setValueByKey(varName, state, $(ele).val());
    });
}

/**
* gyBankBranchCdDataAccessName共通処理
* 銀行コード、支店コードの名称表示の同期など
* 
* @param {any} state スコープ
* @param {any} props 要素属性
* @param {any} result 検索結果データ
* @param {any} inputdata 入力値
* @param {any} asyncService 非同期通信サービス
* @param {any} GyCtrl 業務コントロール
* @param {any} errMsgService 
* @param {any} addArgs 
* @returns 
*/
export const setBankBranch = (state, props, result, inputdata, asyncService, GyCtrl, errMsgService, addArgs) => {

    // 銀行コードを表すフラグが設定されていない場合処理しない
    if (!result.isGnko && !result.isForm && props.searchform !== "bank-branch") return;

    // name属性のセレクター定義
    const nameSelector = '[name="' + props.name + '"]';
    // searchform属性のセレクター定義
    const searchformSelector = 'input[searchform="' + props.searchform + '"]';

    // フォーカスしていた銀行コードまたは支店コードのオブジェクトを取得する
    const bankbranchObj = $(searchformSelector);
    // 支店コードにフォーカスしていたなら銀行コードのオブジェクトを取得する
    const bankObj = $(searchformSelector + "[bank]");
    // 銀行コードにフォーカスしていたなら支店コードのオブジェクトを取得する
    const branchObj = $(searchformSelector + "[branch]");

    const bankName = bankObj.attr("name");              // 銀行コードのname属性値
    const bankNgModel = bankObj.attr("ng-model");       // 銀行コードのng-model名
    const branchName = branchObj.attr("name");          // 支店コードのname属性
    const branchNgModel = branchObj.attr("ng-model");   // 支店コードのng-model名
    const gnkocd = getValueByKey(bankNgModel, state);   // 銀行コードの値
    const stencd = getValueByKey(branchNgModel, state); // 支店コードの値

    // モーダル行から取得したデータの設定
    if (isEmpty(inputdata)) {
        const data = result.row;
        // データを該当する各ng-modelに設定する
        setValueByKey(bankNgModel, state, data.gnkocd);   // 銀行コード
        setValueByKey(branchNgModel, state, data.stencd); // 支店コード

        const bankSearchName = getSearchName(bankName);
        const branchSearchName = getSearchName(branchName);

        if (isNotEmpty(bankSearchName)) setValueByKey(bankSearchName, state, data.gnkomeiknji);   // 銀行名称
        if (isNotEmpty(branchSearchName)) setValueByKey(branchSearchName, state, data.stenmeiknji); // 支店名称
        return;
    }

    // 銀行コードと支店コード両方の値がある場合（テキストボックスから入力した場合に処理する）
    if (!!gnkocd && !!stencd) {
        asyncService.async(GyCtrl.getBankBranchcd({ "gnkocd": gnkocd, "stencd": stencd }).$promise, function (result) {
            const idata = result.data;

            // エラーチェックを行う
            // TODO
            // var isNotError = checkExistType(state, props, idata, "ECMN0390", "EMNT0270", null, errMsgService);
            const isNotError = null;
            // エラーではない場合、表示名称に値を設定する
            if (isNotError) {
                if (isNotEmpty(idata)) {
                    // データを該当する各ng-modelに設定する
                    setValueByKey(getSearchName(bankName), state, idata.gnkomeiknji);   // 銀行名
                    setValueByKey(getSearchName(branchName), state, idata.stenmeiknji); // 支店名
                }

                errMsgService.delMsg(bankName);
                errMsgService.delMsg(branchName);

                // 内部データ保持・コールバック関数実行・エラーメッセージ削除処理
                // TODO
                // execFinallyFunc(state, props, idata, errMsgService, addArgs);
            } else {
                // エラーのとき、エラーコールバック関数が設定されている場合実行する
                if (isNotEmpty(addArgs.errCallbackFunc)) addArgs.errCallbackFunc(addArgs.errCallbackParam);
            }
        });
    }
}

/**
* 照会画面IDを返す
* 
* @param {any} searchformName 
*/
export const getModalGmnId = (searchformName) => {
    // 定義のないsearchformの場合は処理しない
    if (isEmpty(searchFormMap[searchformName])) return;

    // searchFormMapに定義されているコントローラ名を取得する
    const INFController = searchFormMap[searchformName].modal.component;

    // コントローラ名の中から照会画面ID（INFF***）を抽出する
    return INFController;
}
export const initPssValue = (state, modalGmnIdElements) => {
    modalGmnIdElements.forEach((ele, idx) => {
        const gmnId = $(ele).attr("pass-gmnid");
        const gmnIdConst = constMap.requestParam[gmnId];
        gmnIdConst.forEach((varName) => {
            if (typeof varName === "string") {
                // パラメータを設定する
                setValueByKey(varName, state, "");
            }
        });
    })
}

/**
* 定義から照会画面の変数名を返す
* 
* @param {any} gmnId 
* @param {any} passName 
* @returns 
*/
export const getVarName = (gmnId, passName) => {
    // 定義のない照会画面の場合は処理しない
    if (isEmpty(constMap.requestParam[gmnId])) return;

    // 定義されている変数名を返す
    return constMap.requestParam[gmnId][passName];
}

/**
* 業務系マスタデータ設定処理
* 
* @param {any} state スコープ
* @param {any} props 要素属性
* @param {any} data 設定する値
*/
export const setGyData = (state, props, data) => {

    // モーダル画面の中にリストコントロールがあり、gyDataを取得する項目がある場合
    // スコープの親階層のさらに一つ上の親階層に保持する（画面側でgyDataが参照できないため）
    // setValueByKey("gyData." + props.name, state, data);
}

/**
* 必須項目入力状態判定
* 
* @param {any} isLogin 
*/
export const getRequireFlg = (isLogin) => {
    const inputList = document.body.querySelectorAll('input.require:not(:disabled)');
    for (let i = 0; i < inputList.length; i++) {
        const obj = inputList[i];
        if (isEmpty(obj.value)) {
            // ログイン画面のみ処理する
            if (isLogin) {
                // ログイン画面表示時にブラウザ保存しているログイン情報の値が自動入力されたときの考慮
                const autofiiled = window.getComputedStyle(obj, null).getPropertyValue("-webkit-box-shadow");
                if (autofiiled != "none") return true; // ループ処理 continue
            }
            return true;// ループ処理 break
        }
    }
    // セレクトボックスの必須項目の状態を確認
    const selectList = document.body.querySelectorAll('select.require:not(:disabled)');
    for (let i = 0; i < selectList.length; i++) {
        const obj = selectList[i];
        if (isEmpty(obj.value)) {
            return true; // ループ処理 break
        }
    }
    return false;
}

export const execFinallyFunc = (scope, props, idata, errMsgService, addArgs) => {
    if (isNotEmpty(idata)) {
        // 画面に表示しない項目を含むデータの保持
        setGyData(scope, props, idata);
    }
    // 正常の場合、エラーメッセージを削除する
    errMsgService.delMsgLabel(props);
    // コールバック関数の設定がある場合実行する
    execCallBackFunc(addArgs);
}


// コールバック関数の実施
export const execCallBackFunc = (addArgs) => {
    if (isNotEmpty(addArgs.callbackFunc)) addArgs.callbackFunc(addArgs.callbackParam);
};

// 対象のフォーカス先を設定する
export const setTargetFocus = (nameValue, targetIndex) => {
    const nameSelector = "[name='" + nameValue + "']";
    const notSelector = "button[ng-model]";
    const element = $(nameSelector);
    // DOMが取得できないかつインデックスが設定されている場合
    if (element.length == 0 && isNotEmpty(targetIndex)) {
        nameSelector = "[name='" + nameValue + targetIndex + "']";
        element = $(nameSelector);
    }

    // 照会画面と親画面で同じname属性が使われているとき
    if (element.length > 1) {
        // 照会画面のコントロールにフォーカスする
        element.eq(0).not(notSelector).focus();
        return;
    }

    // 対象のコントロールにフォーカスする
    element.not(notSelector).focus();

    if (element.length == 0) {
        console.log(nameSelector);
        return false;
    }
    var current = document.activeElement;
    return element[0].getAttribute("name") == current.getAttribute("name");
};
